export class ContratoMenuModel {
    active: boolean
    chaveContrato: Array<String>
    nivelRestricao: number = ContratoMenuModel.NIVEL_RESTRICAO_ALTO

    static NIVEL_RESTRICAO_BAIXO: number = 0
    static NIVEL_RESTRICAO_ALTO: number = 1
}